import { LOCALES } from '../../locales';

export default {
  [LOCALES.DE]: {
    developer_hello: 'Hallo',
    developer_edit: 'Edit next page {path} and ...',
  },
};
